import React from "react";
import DeleteModal from "../../Modal/DeleteModal";

export function StateDeleteModal({
  isLoadingDeleteState,
  handleDeleteHide,
  isDeleteModal,
  data,
  handleOnClickOfDeleteStateButton,
}) {
  return (
    <>
      <DeleteModal
        isLoading={isLoadingDeleteState}
        handleDeleteHide={handleDeleteHide}
        isDeleteModal={isDeleteModal}
        title={"Delete State"}
        message={"Are you sure to permanently delete this state?"}
        onClickOfSaveButton={handleOnClickOfDeleteStateButton}
        onClickOfCancelButton={handleDeleteHide}
        saveButtonLabel={"Delete"}
        cancelButtonLabel={"Cancel"}
      />
    </>
  );
}
